function toggleTheme(){
  var r=document.documentElement;
  var next=r.getAttribute('data-theme')==='dark'?'light':'dark';
  r.setAttribute('data-theme',next);
  try{localStorage.setItem('heft-theme',next)}catch(e){}
}
function toggleDrawer(open){
  var n=document.getElementById('mainnav');
  var s=document.getElementById('navScrim');
  var h=document.querySelector('.masthead');
  if(!n||!s)return;
  n.classList.toggle('open',open);
  s.classList.toggle('show',open);
  if(h&&document.body.classList.contains('home')){
    h.style.zIndex=open?'80':'';
  }
  document.body.style.overflow=open?'hidden':'';
}
try{
  var saved=localStorage.getItem('heft-theme');
  if(saved){document.documentElement.setAttribute('data-theme',saved)}
  else{
    var h=new Date().getHours();
    document.documentElement.setAttribute('data-theme',(h>=19||h<7)?'dark':'light');
  }
}catch(e){}
